export default ({ tlds }) => ({
  tlds
})
